module.exports = __webpack_public_path__ + "img/thumb-003-02.c8fd2296.png";